import { mapGetters } from 'vuex';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import http from '../helpers/http';
import { SET_USER } from '../store';

const logoutMixin = {
  computed: {
    ...mapGetters(['role']),
  },
  subscriptions() {
    this.onLogout$ = new Subject();
    return {
      logout: this.onLogout$
        .pipe(
          switchMap(() => http({
            method: 'POST',
            url: `/agc-${this.role}-api/auth/logout`,
          }, () => {
            // logout anyway
            const path = `${this.role === 'admin' ? '/admin' : ''}/login`;
            this.$store.commit(SET_USER, null);
            this.$router.push({
              path,
              query: {
                redirect: this.$route.fullPath,
              },
            });
          })),
        ),
    };
  },
};

export default logoutMixin;
